import { Control } from 'react-hook-form';
import { SelectItem, Typography } from '@braskai/ui-kit';
import { ControlledTextField } from '@/shared/ui/form/TextField';
import { ControlledSelect } from '@/shared/ui/form/ControlledSelect';
import { FormValues, FormValuesOption, Option as OptionType } from '../../../../lib/types';
import { OTHER } from '../../../../lib/constants';
import { Container } from './styled';

type SelectProps = {
  control: Control<FormValues>;
  controller: OptionType['controller'];
  label: OptionType['label'];
  options: OptionType['options'];
  value: FormValuesOption;
  disabled: boolean;
  onResetTextField: () => void;
};

const renderValue = (selected?: string) => (
  <Typography variant="body-1" color={selected ? 'grey.900' : 'grey.500'}>
    {selected || 'Choose'}
  </Typography>
);

export const Select = ({ onResetTextField, value, label, options, control, controller, disabled }: SelectProps) => {
  const isTextField = value.option.toLowerCase() === OTHER;

  return (
    <Container hasGap={isTextField}>
      <ControlledSelect
        controllerName={`${controller}.option`}
        control={control}
        label={label}
        isMenuInModal
        disabled={disabled}
        renderValue={renderValue}
      >
        {options.map((option) => (
          <SelectItem key={option} value={option} onClick={onResetTextField}>
            {option}
          </SelectItem>
        ))}
      </ControlledSelect>

      {isTextField ? (
        <ControlledTextField
          variant="outlined"
          control={control}
          disabled={disabled}
          fieldName={`${controller}.text`}
          placeholder="Your option"
        />
      ) : null}
    </Container>
  );
};
